export default "__VITE_ASSET__5d3dda43__"